<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
      class="table-style"
      stripe
      highlight-hover-row
      show-footer
      show-overflow
      max-height="500"
      border="none"
      :loading="loading"
      :data="invoiceListData"
      :auto-resize="true"
      align="center"
      :footer-method="footerMethod"
      @filter-change="filterTypeMethod"
      ref="xTable"
    >
      <vxe-table-column
        type="seq"
        title="序号"
        align="center"
        width="60"
      ></vxe-table-column>
      <vxe-table-column field="detailNum" title="详情编号" min-width="130">
        <template slot-scope="{ row }">
          <span
            @click="viewDetail(row)"
            style="color: #2d8cf0; cursor: pointer"
            >{{ row.detailNum }}</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column field="flowNum" title="流程编号" min-width="130">
        <template slot-scope="{ row }">
          <span
            @click="openProcedureDetail(row.flowId, 2)"
            style="color: #2d8cf0; cursor: pointer"
            >{{ row.flowNum }}</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column field="orderNum" title="子订单号" min-width="130">
        <template slot-scope="{ row }">
          <span
            @click="openOrder(row)"
            style="color: #2d8cf0; cursor: pointer"
            >{{ row.orderNum }}</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="ownName"
        title="所属方"
        :filters="filterOwnName"
        min-width="200"
      ></vxe-table-column>
      <vxe-table-column
        field="clientName"
        title="客户名称"
        :filters="filterclientName"
        min-width="120"
      ></vxe-table-column>
      <vxe-table-column
        field="salesMan"
        title="业务员"
        min-width="100"
      ></vxe-table-column>
      <vxe-table-column field="addDate" title="日期" min-width="140">
        <template v-slot="{ row }">
          <span>{{ row.addDate | timeFormatDate }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="note"
        title="摘要"
        min-width="140"
      ></vxe-table-column>
      <vxe-table-column
        field="debitAmount"
        title="借方金额"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column
        field="creditAmount"
        title="贷方金额"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column
        field="balance"
        title="余额"
        min-width="120"
      ></vxe-table-column>
    </vxe-table>
    <!-- <vxe-pager
      background
      size="small"
      :current-page.sync="page.currentPage"
      :page-size.sync="page.pageSize"
      :total="page.totalResult"
      @page-change="handlePageChange"
    ></vxe-pager> -->
    <vxe-modal
      v-model="isShowCollectionDetail"
      width="1300"
      height="680"
      resize
      remember
    >
      <div slot="title">收付款详情</div>
      <collection-detail
        :cate="cate"
        :isShow="isShowCollectionDetail"
        ref="collectionDetail"
        @close="isShowCollectionDetail = false"
      ></collection-detail>
    </vxe-modal>
    <vxe-modal
      v-model="isShowPaymentDetail"
      width="1300"
      height="680"
      resize
      remember
    >
      <div slot="title">收付款详情</div>
      <payment-detail
        :cate="cate"
        :isShow="isShowPaymentDetail"
        ref="paymentDetail"
        @close="isShowPaymentDetail = false"
      ></payment-detail>
    </vxe-modal>
    <vxe-modal
      v-model="isShowInvoiceDetail"
      title="发票详情"
      width="1300"
      height="660"
      resize
      remember
    >
      <invoice-detail
        :cate="cate"
        :isShow="isShowInvoiceDetail"
        ref="invoiceDetail"
        @close="isShowInvoiceDetail = false"
      ></invoice-detail>
    </vxe-modal>
        <vxe-modal v-model="isShowCarryOverDetail" title="结转详情" width="1300" height="460" resize remember>
      <carry-over-detail :isShow="isShowCarryOverDetail" ref="carryOverDetail"
                      @close="isShowCarryOverDetail = false"></carry-over-detail>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { getFilterObj } from "@/utils/util";
import openOrderDetail from "@/mixin/viewOrderDetail";
import CollectionDetail from "@/views/payment/CollectionDetail.vue";
import PaymentDetail from "@/views/payment/PaymentDetail.vue";
import InvoiceDetail from "@/views/invoice/InvoiceDetail.vue";
import CarryOverDetail from "@/views/payment/CarryOverDetail.vue";

// 销项发票
export default {
  mixins: [openOrderDetail],
  components: { CollectionDetail, PaymentDetail, InvoiceDetail, CarryOverDetail },
  props: {
    id: Number,
    pageTab: String,
    cate: {
      type: String,
      default: "Collection",
    },
  },

  data() {
    return {
      isShowCollectionDetail: false,
      isShowPaymentDetail: false,
      isShowInvoiceDetail: false,
      isShowCarryOverDetail: false,
      loading: false,
      invoiceListData: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      countRtnVo: {},
      paymentCate: null,
      collectionCate: null,
      filterOwnName: [],
      filterclientName: [],
      ownName: null,
      clientName: null,
    };
  },
  watch: {
    // id(nv, ov) {
    //   if (nv !== ov && nv !== undefined) {
    //     this.getPayListData();
    //   }
    // },
    pageTab() {
      this.pageTab === "tab9" ? this.getPayListData() : "";
    },
  },
  //   activated() {
  //     // this.getInvoiceListData();
  //     this.$bus.$on("allOrderDetailRenovate", (data) => {
  //       data === true ? this.getPayListData() : "";
  //     });
  //   },
  methods: {
    init() {
      this.page.currentPage = 1;
      this.getPayListData();
    },
    filterTypeMethod({ column, property, values, datas, filters, $event }) {
      this.page.currentPage = 1;
      if (values.length > 0) {
        if (property == "ownName") {
          this.ownName = values;
        } else if (property == "clientName") {
          this.clientName = values;
        }
      } else {
        this.ownName = null;
        this.clientName = null;
      }
      this.getPayListDataFilter();
    },
    async getPayListDataFilter() {
      this.invoiceListData = [];
      this.loading = true;
      let res = await $api.report.get("saleManAmountByChainId", {
        chainId: this.id,
        // page: this.page.currentPage,
        // rows: this.page.pageSize,
        orderBy: 2,
        ownName: this.ownName,
        clientName: this.clientName,
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.countRtnVo = res.data.countRtnVo;
        let invoiceListData = res.data;
        for (let i = 0; i < invoiceListData.length; i++) {
          let obj = invoiceListData[i];
          if (i === 0) {
            obj.balance = (
              0 +
              Number(invoiceListData[i].debitAmount) -
              Number(invoiceListData[i].creditAmount)
            ).toFixed(2);
          } else {
            obj.balance = (
              Number(invoiceListData[i - 1].balance) +
              Number(invoiceListData[i].debitAmount) -
              Number(invoiceListData[i].creditAmount)
            ).toFixed(2);
          }
          this.invoiceListData.push(obj);
        }
        // this.invoiceListData = invoiceListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getPayListData() {
      this.filterOwnName = [];
      this.filterclientName = [];
      this.invoiceListData = [];
      this.loading = true;
      let res = await $api.report.get("saleManAmountByChainId", {
        chainId: this.id,
        // page: this.page.currentPage,
        // rows: this.page.pageSize,
        orderBy: 2,
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.countRtnVo = res.data.countRtnVo;
        let invoiceListData = res.data;
        const xTable = this.$refs.xTable;
        const ownNameColumn = xTable.getColumnByField("ownName");
        const clientNameColumn = xTable.getColumnByField("clientName");
        invoiceListData.map((i) => {
          getFilterObj(this.filterOwnName, i.ownName);
          getFilterObj(this.filterclientName, i.clientName);
        });
        xTable.setFilter(ownNameColumn, this.filterOwnName);
        xTable.setFilter(clientNameColumn, this.filterclientName);
        xTable.updateData();
        for (let i = 0; i < invoiceListData.length; i++) {
          let obj = invoiceListData[i];
          if (i === 0) {
            obj.balance = (
              0 +
              Number(invoiceListData[i].debitAmount) -
              Number(invoiceListData[i].creditAmount)
            ).toFixed(2);
          } else {
            obj.balance = (
              Number(invoiceListData[i - 1].balance) +
              Number(invoiceListData[i].debitAmount) -
              Number(invoiceListData[i].creditAmount)
            ).toFixed(2);
          }
          this.invoiceListData.push(obj);
        }
        // this.invoiceListData = invoiceListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      // 分页
      this.page.currentPage = currentPage;
      this.page.pageSize = pageSize;
      this.getPayListDataFilter();
    },
    footerMethod({ columns, data }) {
      let i = data.length
      let balance = i > 0 ? data[i-1].balance: ''
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "合计";
          }
          if (["debitAmount", "creditAmount"].includes(column.property)) {
            return this.$utils.sum(data, column.property);
          }
          if (["balance"].includes(column.property)) {
            return balance;
          }
          return null;
        }),
        // columns.map((column, columnIndex) => {
        //   if (columnIndex === 1) {
        //     return "全部合计";
        //   }
        //   if (["balanceAmount"].includes(column.property)) {
        //     return this.countRtnVo.totalBalanceAmount;
        //   }

        //   return null;
        // }),
      ];
    },
    cellClick(e) {
      // let field = e.column.property;
      if (e.paymentType !== 1 && e.paymentsState == 2) {
        this.isShowPaymentDetail = true;
        this.paymentCate = e.sellerLv2Name ? "SellerPayment" : "Payment";
        this.$refs.paymentDetail.init(e.id, this.paymentCate);
      } else {
        this.isShowCollectionDetail = true;
        this.collectionCate = "Collection";
        this.$refs.collectionDetail.init(e.id);
      }
    },
    openOrder(row) {
      let firWord = row.orderNum.substr(0, 1);
      if (firWord === "G") {
        this.openOrderDetail(row.orderId, 1);
        // orderDetail(this, 1, row.ordersId)
      } else if (firWord === "S") {
        this.openOrderDetail(row.orderId, 2);
        // orderDetail(this, 2, row.ordersId)
      } else {
        this.openOrderDetail(row.orderId, 3);
      }
    },
    viewDetail(row) {
      switch (row.flowTypeCode) {
        case 1:
          this.cate = "Collection";
          this.isShowCollectionDetail = true;
          this.$refs.collectionDetail.setEdit(false);
          this.$refs.collectionDetail.init(row.detailId);
          break;
        case 2:
          this.cate = "Payment";
          this.isShowPaymentDetail = true;
          this.$refs.paymentDetail.setEdit(false);
          this.$refs.paymentDetail.init(row.detailId);
          break;
        case 4:
          this.cate = "Sales";
          this.isShowInvoiceDetail = true;
          this.$refs.invoiceDetail.setEdit(false);
          this.$refs.invoiceDetail.initDetail(row.invoiceId);
          break;
        case 5:
          this.cate = "";
          this.isShowInvoiceDetail = true;
          this.$refs.invoiceDetail.setEdit(false);
          this.$refs.invoiceDetail.initDetail(row.invoiceId);
          break;
        case 6: // 结转流程详情
            this.isShowCarryOverDetail = true;
            this.$refs.carryOverDetail.initDetail(row.detailId);
            break;    
      }
    },
  },
};
</script>

<style>
</style>